import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { walletKeys } from '../../constants/wallet';
export function useInvalidateWallet() {
    const queryClient = useQueryClient();
    return useCallback(() => {
        queryClient.invalidateQueries({ queryKey: walletKeys.all });
    }, [queryClient]);
}
